import React from 'react'
import {
  List,
  Datagrid,
  TextField,
  DateField,
  Filter,
  ReferenceField,
} from 'react-admin'
import AutocompleteReferenceInput from '../AutocompleteReferenceInput'
import ListActions from '../common/ListActions'

const UserOrganizationRoleList = (props) => (
  <List {...props} filters={<Filters />} actions={<ListActions {...props} />}>
    <Datagrid rowClick='edit'>
      <ReferenceField source='organization_id' reference='organization'>
        <TextField source='name' />
      </ReferenceField>
      <ReferenceField source='user_id' reference='user'>
        <TextField source='username' />
      </ReferenceField>
      <TextField source='role' />
      <DateField source='created_at' />
      <DateField source='updated_at' />
    </Datagrid>
  </List>
)

const Filters = (props) => (
  <Filter {...props}>
    <AutocompleteReferenceInput
      label='Search by Username'
      source='user_id'
      reference='user'
      optionText='username'
      allowEmpty
      alwaysOn
    />
    <AutocompleteReferenceInput
      label='Search by Organization'
      source='organization_id'
      reference='organization'
      optionText='name'
      allowEmpty
      alwaysOn
    />
  </Filter>
)

export default UserOrganizationRoleList
